import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { PlanDelete_PlanListPage_Mutation } from "./mutation";
import { PlanList_PlanListPage_Query } from "../../query/fetch-plan-list/query";

type Props = {
	hotelID: string;
};

export const useDeletePlan = ({ hotelID }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { mutationFunc } = useCustomMutation(PlanDelete_PlanListPage_Mutation);
	const onDeletePlan = useCallback(
		async (planID: string) => {
			if (!window.confirm("本当に削除しますか？")) return;

			showLoadingScreenCallback();

			const { errors } = await mutationFunc({
				variables: {
					hotelID,
					planID,
				},
				refetchQueries: [
					{
						query: PlanList_PlanListPage_Query,
						variables: { hotelID },
					},
				],
			}).finally(() => hideLoadingScreenCallback());

			if (!errors) {
				notifyUserEventInfo({
					title: "プランを削除しました",
				});
			}
		},
		[hideLoadingScreenCallback, hotelID, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onDeletePlan,
	};
};
